import { render, staticRenderFns } from "./hcp-tag-select.vue?vue&type=template&id=1faf6717&scoped=true"
import script from "./hcp-tag-select.vue?vue&type=script&lang=js"
export * from "./hcp-tag-select.vue?vue&type=script&lang=js"
import style0 from "./hcp-tag-select.vue?vue&type=style&index=0&id=1faf6717&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1faf6717",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/LRL_LCDDMAC_eMSL_CFC/LRL_LCDDMAC_eMSL_CFC/Frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1faf6717')) {
      api.createRecord('1faf6717', component.options)
    } else {
      api.reload('1faf6717', component.options)
    }
    module.hot.accept("./hcp-tag-select.vue?vue&type=template&id=1faf6717&scoped=true", function () {
      api.rerender('1faf6717', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hcp-tag-select.vue"
export default component.exports